import React from "react";
import "./SentinelTab.css";
import {Alert, Card, Col, Container, Row, Table} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../../../../services/CamplaCoreService";
import {
  faCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import APIErrorHelper from "../../../../../helpers/APIErrorHelper";

class SentinelTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: {
        server: "",
        connected: false,
        error: null
      },
      certificates: [],
      apiError: null
    };

    this.loadData = this.loadData.bind(this);
    this.loadRaLogs = this.loadRaLogs.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  async loadRaLogs(){
    try {
      const logs = await CamplaCoreService.getDeviceLogs();
      this.setState({raLogs: logs, lastReload: new Date().toISOString()});
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        )
      });
    }
  }

  async loadData() {
    try {
      const {sentinel} = await CamplaCoreService.getSentinelStatus();
      if (sentinel !== null && sentinel.status !== null)
        this.setState({status: sentinel.status});
      if (sentinel !== null && Array.isArray(sentinel.certificates)){
        this.setState({certificates: sentinel.certificates});
      }
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
            err,
            () => this.setState({ apiError: "" }),
            {},
            this.props.t
        )
      });
    }
  }

  render(){
    const { t } = this.props;
    const certs = this.state.certificates
        .map(cert => {
          cert["expiresIn"] = Math.ceil(Math.abs(Date.now() - Date.parse(cert.validTo)) / (1000 * 60 * 60 * 24))
          return cert;
        })
        .map(cert => (
          <Row className="mt-3">
            <Col>
              <Card className="dashboard-panel">
                <Card.Header>{cert.subject
                    .replaceAll("\n", "")
                    .replace(/^.*CN=/mg, "")}</Card.Header>
                <Card.Body>
                  <Table size="sm">
                    <tbody>
                      <tr>
                        <td><b>{t("Dashboard.AdminDashboard.SentinelTab.CertificateSubject")}</b></td>
                        <td>{cert.subject.replaceAll("\n", ",")}</td>
                      </tr>
                      <tr>
                        <td><b>{t("Dashboard.AdminDashboard.SentinelTab.CertificateIssuer")}</b></td>
                        <td>{cert.issuer}</td>
                      </tr>
                      <tr>
                        <td><b>{t("Dashboard.AdminDashboard.SentinelTab.CertificateValidTo")}</b></td>
                        <td>{new Date(Date.parse(cert.validTo)).toISOString()} <b>
                          ({t("Dashboard.AdminDashboard.SentinelTab.CertificateExpiresIn")} {cert.expiresIn} {t("Dashboard.AdminDashboard.SentinelTab.Days")})</b>
                        </td>
                      </tr>
                    <tr>
                      <td style={{width: "150px"}}>
                        <b>{t("Dashboard.AdminDashboard.SentinelTab.CertificateValidFrom")}</b>
                      </td>
                      <td>{new Date(Date.parse(cert.validFrom)).toISOString()}</td>
                    </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
      ))
    return (
        <Container className="ml-0 mr-0 pl-0 pr-0 pt-3">
          <Row>
            <Col>
              <h4>{t("Dashboard.AdminDashboard.SentinelTab.SentinelInstance")}</h4>
            </Col>
          </Row>
          <Row>
            <Col>
                {this.state.status.connected ? <div>
                  <Table bordered>
                    <thead>
                    <tr>
                      <th></th>
                      <th>Server</th>
                      <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><FontAwesomeIcon icon={faCircle} className="color-green" /></td>
                        <td>{this.state.status.server}</td>
                        <td>
                          {t("Dashboard.AdminDashboard.SentinelTab.SentinelServerConnected")} ({new Date().toISOString()})
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div> : <div>
                  <Table>
                    <tbody>
                    <tr>
                      <td><FontAwesomeIcon icon={faCircle} className="color-red" /></td>
                      <td>{this.state.status.server}</td>
                      <td>
                        {t("Dashboard.AdminDashboard.SentinelTab.SentinelServerError")} ({new Date().toISOString()})
                        <Alert variant="danger">
                          {this.state.status.error}
                        </Alert>
                      </td>
                    </tr>
                    </tbody>
                  </Table>
                </div>}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <h4>{t("Dashboard.AdminDashboard.SentinelTab.Certificates")}</h4>
            </Col>
          </Row>
          {certs}
        </Container>
    );
  }
}

export default withTranslation()(SentinelTab);
